export type PtBrToolCategory =
  | "Sorteios & Escolhas"
  | "Roletas Interativas"
  | "Grupos & Equipes"
  | "Sala de Aula & Escola"
  | "Jogos & Diversão";

export interface PtBrToolMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  category: PtBrToolCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const PT_BR_CATEGORIES: PtBrToolCategory[] = [
  "Sorteios & Escolhas",
  "Roletas Interativas",
  "Grupos & Equipes",
  "Sala de Aula & Escola",
  "Jogos & Diversão",
];

export const PT_BR_TOOLS: PtBrToolMeta[] = [
  {
    slug: "sorteador-de-nomes-online",
    enSlug: "random-name-picker",
    name: "Sorteador de Nomes Online",
    tagline: "Sorteie nomes ou alunos de forma rápida, justa e com animação interativa.",
    category: "Sorteios & Escolhas",
    icon: "Shuffle",
    featured: true,
    keywords: ["sorteador de nomes", "sortear nomes online", "sorteador de nomes aleatorio", "sorteio de nomes grátis"],
  },
  {
    slug: "sorteador-de-alunos",
    enSlug: "random-student-picker",
    name: "Sorteador de Alunos para Sala de Aula",
    tagline: "Insira a lista da turma e sorteie um aluno sem repetições injustas.",
    category: "Sorteios & Escolhas",
    icon: "GraduationCap",
    featured: true,
    keywords: ["sorteador de alunos", "sortear aluno", "lista de alunos sorteio", "sorteio sala de aula"],
  },
  {
    slug: "roleta-da-sorte-online",
    enSlug: "spin-the-wheel",
    name: "Roleta da Sorte Online (Girar a Roleta)",
    tagline: "Gire a roleta interativa colorida para tomar decisões e fazer sorteios.",
    category: "Roletas Interativas",
    icon: "Disc3",
    featured: true,
    keywords: ["roleta da sorte", "girar roleta online", "roleta de decisoes", "roleta aleatoria online"],
  },
  {
    slug: "roleta-de-nomes",
    enSlug: "wheel-of-names",
    name: "Roleta de Nomes Online",
    tagline: "Coloque os nomes na roleta e sorteie o vencedor ao vivo com som e efeitos.",
    category: "Roletas Interativas",
    icon: "Disc3",
    featured: true,
    keywords: ["roleta de nomes", "roleta sorteio nomes", "girar roleta de nomes", "roleta personalizada nomes"],
  },
  {
    slug: "roleta-sim-ou-nao",
    enSlug: "yes-or-no-wheel",
    name: "Roleta Sim ou Não",
    tagline: "Tire dúvidas e tome decisões rápidas em 50/50 girando a roleta.",
    category: "Roletas Interativas",
    icon: "HelpCircle",
    featured: true,
    keywords: ["roleta sim ou nao", "gerador sim ou nao", "decisao sim ou nao", "roleta 50 50"],
  },
  {
    slug: "roleta-de-premios",
    enSlug: "prize-wheel",
    name: "Roleta de Prêmios e Brindes",
    tagline: "Gire a roleta de prêmios para sorteios, recompensas escolares e brincadeiras.",
    category: "Roletas Interativas",
    icon: "Gift",
    featured: true,
    keywords: ["roleta de premios", "roleta de brindes", "roleta sorteio premios", "roleta promocional"],
  },
  {
    slug: "roleta-de-numeros",
    enSlug: "number-wheel",
    name: "Roleta de Números Aleatórios",
    tagline: "Sorteie números de 1 a 100 ou defina seu próprio intervalo na roleta.",
    category: "Roletas Interativas",
    icon: "Hash",
    keywords: ["roleta de numeros", "roleta numerica online", "sorteador de numero roleta"],
  },
  {
    slug: "roleta-o-que-comer",
    enSlug: "food-wheel",
    name: "Roleta O Que Comer Hoje",
    tagline: "Em dúvida do que comer no almoço ou janta? Gire a roleta de comida!",
    category: "Roletas Interativas",
    icon: "Utensils",
    keywords: ["roleta o que comer", "o que comer hoje roleta", "escolher comida roleta"],
  },
  {
    slug: "gerador-de-equipes",
    enSlug: "team-generator",
    name: "Gerador de Equipes e Times Aleatórios",
    tagline: "Divida turmas e grupos em times equilibrados com apenas um clique.",
    category: "Grupos & Equipes",
    icon: "Users",
    featured: true,
    keywords: ["gerador de equipes", "formar times aleatorios", "dividir times online", "gerador de times"],
  },
  {
    slug: "gerador-de-grupos-aleatorios",
    enSlug: "group-maker",
    name: "Gerador de Grupos Aleatórios",
    tagline: "Monte grupos por quantidade de integrantes ou número total de grupos.",
    category: "Grupos & Equipes",
    icon: "UsersRound",
    keywords: ["gerador de grupos aleatorios", "montar grupos online", "dividir grupo trabalho"],
  },
  {
    slug: "gerador-de-duplas",
    enSlug: "partner-generator",
    name: "Gerador de Duplas e Pares",
    tagline: "Crie duplas aleatórias instantaneamente para trabalhos e atividades.",
    category: "Grupos & Equipes",
    icon: "Handshake",
    keywords: ["gerador de duplas", "sorteador de duplas", "montar duplas aleatorias"],
  },
  {
    slug: "gerador-de-numeros-aleatorios",
    enSlug: "random-number-generator",
    name: "Gerador de Números Aleatórios",
    tagline: "Sorteie números em qualquer intervalo desejado sem repetições.",
    category: "Sorteios & Escolhas",
    icon: "Hash",
    keywords: ["gerador de numeros aleatorios", "sorteador de numeros", "gerador de numeros online"],
  },
  {
    slug: "dado-virtual-online",
    enSlug: "dice-roller",
    name: "Dado Virtual Online (Jogar Dados)",
    tagline: "Jogue dados virtuais de 4 a 100 lados com rolagem animada e realista.",
    category: "Jogos & Diversão",
    icon: "Dices",
    keywords: ["dado virtual", "jogar dado online", "girar dado virtual", "dado d6 online"],
  },
  {
    slug: "cara-ou-coroa-online",
    enSlug: "coin-flip",
    name: "Cara ou Coroa Online",
    tagline: "Jogue a moeda virtual e decida quem começa em um segundo.",
    category: "Jogos & Diversão",
    icon: "CircleDollarSign",
    keywords: ["cara ou coroa", "cara ou coroa online", "jogar moeda online", "girar moeda cara ou coroa"],
  },
  {
    slug: "cronometro-para-sala-de-aula",
    enSlug: "classroom-timer",
    name: "Temporizador e Cronômetro para Sala de Aula",
    tagline: "Contagem regressiva gigante ideal para projetores e tarefas com tempo.",
    category: "Sala de Aula & Escola",
    icon: "Timer",
    featured: true,
    keywords: ["cronometro sala de aula", "temporizador online", "contagem regressiva escola"],
  },
  {
    slug: "mapa-de-sala-aleatorio",
    enSlug: "seating-chart",
    name: "Gerador de Mapa de Sala Aleatório",
    tagline: "Organize carteiras e lugares de alunos em fileiras ou duplas para imprimir.",
    category: "Sala de Aula & Escola",
    icon: "LayoutGrid",
    keywords: ["mapa de sala", "mapa de sala aleatorio", "organizar lugares alunos"],
  },
  {
    slug: "sorteador-de-ajudantes-do-dia",
    enSlug: "classroom-helper-picker",
    name: "Sorteador de Ajudantes do Dia",
    tagline: "Distribua tarefas da sala como ajudante do dia e líder de fila.",
    category: "Sala de Aula & Escola",
    icon: "Sparkles",
    keywords: ["ajudante do dia", "sorteador de ajudante", "funcoes da sala de aula"],
  },
  {
    slug: "sorteador-de-letras-do-alfabeto",
    enSlug: "random-letter-picker",
    name: "Sorteador de Letras do Alfabeto (A-Z)",
    tagline: "Sorteie vogais, consoantes ou letras aleatórias para jogos de palavras.",
    category: "Sorteios & Escolhas",
    icon: "Type",
    keywords: ["sorteador de letras", "letra aleatoria", "sortear letra do alfabeto", "stop adedanha letra"],
  },
  {
    slug: "gerador-de-palavras-aleatorias",
    enSlug: "random-word-picker",
    name: "Gerador de Palavras Aleatórias",
    tagline: "Banco de palavras para ortografia, jogos de adivinhação e redação.",
    category: "Sorteios & Escolhas",
    icon: "BookA",
    keywords: ["palavras aleatorias", "gerador de palavras", "sorteador de palavras"],
  },
  {
    slug: "sorteador-de-opcoes-aleatorias",
    enSlug: "random-choice-picker",
    name: "Sorteador de Opções Aleatórias",
    tagline: "Insira suas alternativas e deixe a ferramenta tomar a decisão por você.",
    category: "Sorteios & Escolhas",
    icon: "ListChecks",
    keywords: ["sorteador de opcoes", "tomar decisao online", "escolha aleatoria"],
  },
  {
    slug: "tirar-duvida-sim-ou-nao",
    enSlug: "yes-or-no-picker",
    name: "Gerador Sim ou Não Instantâneo",
    tagline: "Resposta rápida: Sim, Não ou Talvez em um clique.",
    category: "Sorteios & Escolhas",
    icon: "CircleHelp",
    keywords: ["sim ou nao instantaneo", "gerador de respostas sim ou nao"],
  },
  {
    slug: "gerador-de-cores-aleatorias",
    enSlug: "random-color-picker",
    name: "Gerador de Cores Aleatórias",
    tagline: "Gere cores vibrantes com código HEX e nome da cor.",
    category: "Sorteios & Escolhas",
    icon: "Palette",
    keywords: ["gerador de cores", "cor aleatoria hex", "sorteador de cores"],
  },
  {
    slug: "sorteador-de-perguntas",
    enSlug: "random-question-picker",
    name: "Sorteador de Perguntas para Debate",
    tagline: "Perguntas estimulantes para dinâmicas de grupo e debates na aula.",
    category: "Sorteios & Escolhas",
    icon: "MessageCircleQuestion",
    keywords: ["sorteador de perguntas", "perguntas para debate", "perguntas quebra gelo"],
  },
  {
    slug: "roleta-da-sorte-para-sorteios",
    enSlug: "lucky-wheel",
    name: "Roleta da Sorte para Sorteios",
    tagline: "Roleta vibrante para premiações, mimos e prendas.",
    category: "Roletas Interativas",
    icon: "Gift",
    keywords: ["roleta da sorte sorteio", "roleta de mimos", "girar roleta premiada"],
  },
  {
    slug: "roleta-de-atividades",
    enSlug: "activity-wheel",
    name: "Roleta de Atividades Escolares",
    tagline: "Gire para escolher a próxima dinâmica ou exercício da aula.",
    category: "Roletas Interativas",
    icon: "Compass",
    keywords: ["roleta de atividades", "dinamicas de grupo roleta", "roleta pedagogica"],
  },
  {
    slug: "roleta-de-alunos-para-chamada",
    enSlug: "student-wheel",
    name: "Roleta de Alunos para Chamada",
    tagline: "Sua lista de chamada em uma roleta giratória animada.",
    category: "Roletas Interativas",
    icon: "UserRoundCheck",
    keywords: ["roleta de alunos", "roleta chamada escolar", "sorteio de alunos roleta"],
  },
  {
    slug: "roleta-de-decisoes-rapidas",
    enSlug: "decision-wheel",
    name: "Roleta de Decisões Rápidas",
    tagline: "Gire e resolva impasses entre opções personalizadas.",
    category: "Roletas Interativas",
    icon: "Split",
    keywords: ["roleta de decisoes", "tomar decisao roleta", "girar roleta escolhas"],
  },
  {
    slug: "sorteador-ordem-de-apresentacao",
    enSlug: "random-line-order",
    name: "Sorteador de Ordem de Apresentação e Fila",
    tagline: "Crie a ordem justa de trabalhos e filas em um embaralhar rápido.",
    category: "Grupos & Equipes",
    icon: "ListOrdered",
    keywords: ["ordem de apresentacao", "sortear ordem de fila", "embaralhar ordem"],
  },
  {
    slug: "placar-digital-para-sala-de-aula",
    enSlug: "classroom-scoreboard",
    name: "Placar Digital para Sala de Aula",
    tagline: "Acompanhe a pontuação de equipes e gincanas na tela do projetor.",
    category: "Sala de Aula & Escola",
    icon: "Trophy",
    featured: true,
    keywords: ["placar digital sala de aula", "contadorde pontos equipes", "placar gincana"],
  },
  {
    slug: "sorteador-de-tarefas-da-sala",
    enSlug: "classroom-job-picker",
    name: "Sorteador de Tarefas da Sala de Aula",
    tagline: "Atribua todas as funções e responsabilidades da turma de uma vez.",
    category: "Sala de Aula & Escola",
    icon: "ClipboardList",
    keywords: ["sorteador de tarefas", "tarefas sala de aula", "funcoes dos alunos"],
  },
  {
    slug: "gerador-de-ideias-de-atividades",
    enSlug: "activity-picker",
    name: "Gerador de Ideias de Atividades",
    tagline: "Sugestões de aquecimento, trabalhos em equipe e encerramento de aula.",
    category: "Sala de Aula & Escola",
    icon: "Lightbulb",
    keywords: ["ideias de atividades aula", "gerador de atividades escolares"],
  },
  {
    slug: "gerador-de-pausa-ativa-brain-break",
    enSlug: "brain-break-picker",
    name: "Gerador de Pausa Ativa (Brain Break)",
    tagline: "Exercícios curtos de movimentação e relaxamento para renovar o foco.",
    category: "Sala de Aula & Escola",
    icon: "Wind",
    keywords: ["pausa ativa escolar", "brain break sala de aula", "exercicio relaxamento alunos"],
  },
  {
    slug: "gerador-de-mimica-e-imagem",
    enSlug: "charades-generator",
    name: "Gerador de Mímica e Imagem (Jogo da Mímica)",
    tagline: "Animais, objetos, filmes e profissões para encenar em grupo.",
    category: "Jogos & Diversão",
    icon: "Drama",
    featured: true,
    keywords: ["gerador de mimica", "jogo da mimica online", "ideias para mimica"],
  },
  {
    slug: "gerador-de-palavras-para-imagem-e-acao",
    enSlug: "pictionary-word-generator",
    name: "Gerador de Palavras para Desenhar (Imagem & Ação)",
    tagline: "Palavras fáceis, médias e difíceis para jogos de desenho.",
    category: "Jogos & Diversão",
    icon: "Brush",
    keywords: ["palavras para desenhar", "imagem e acao gerador", "pictionary palavras"],
  },
  {
    slug: "gerador-oque-voce-prefere",
    enSlug: "would-you-rather-generator",
    name: "Gerador O Que Você Prefere? (Dilemas Divertidos)",
    tagline: "Perguntas engraçadas para debates e quebra-gelo na turma.",
    category: "Jogos & Diversão",
    icon: "Scale",
    keywords: ["o que voce prefere", "jogo o que voce prefere", "dilemas divertidos"],
  },
  {
    slug: "gerador-de-perguntas-quiz-trivia",
    enSlug: "trivia-question-generator",
    name: "Gerador de Perguntas de Quiz e Conhecimentos Gerais",
    tagline: "Perguntas de ciências, matemática, história e curiosidades.",
    category: "Jogos & Diversão",
    icon: "Brain",
    keywords: ["quiz conhecimentos gerais", "perguntas trivia", "gerador de quiz"],
  },
  {
    slug: "gerador-de-desafios-divertidos",
    enSlug: "random-challenge-generator",
    name: "Gerador de Desafios Divertidos para Sala",
    tagline: "Desafios rápidos, seguros e engraçados para movimentar a turma.",
    category: "Jogos & Diversão",
    icon: "Flame",
    keywords: ["desafios divertidos", "gerador de desafios", "prendas e desafios"],
  },
];

export function getPtBrToolBySlug(slug: string): PtBrToolMeta | undefined {
  return PT_BR_TOOLS.find((t) => t.slug === slug || t.enSlug === slug);
}

export function getEnSlugForPtBrSlug(ptBrSlug: string): string {
  const found = PT_BR_TOOLS.find((t) => t.slug === ptBrSlug || t.enSlug === ptBrSlug);
  return found ? found.enSlug : ptBrSlug;
}

export function getPtBrSlugForEnSlug(enSlug: string): string {
  const found = PT_BR_TOOLS.find((t) => t.enSlug === enSlug || t.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedPtBrTools(currentSlug: string, count = 4): PtBrToolMeta[] {
  const current = getPtBrToolBySlug(currentSlug);
  const sameCategory = PT_BR_TOOLS.filter((t) => t.slug !== current?.slug && t.category === current?.category);
  const others = PT_BR_TOOLS.filter((t) => t.slug !== current?.slug && t.category !== current?.category);
  return [...sameCategory, ...others].slice(0, count);
}
